import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { IManufacturer } from '../../pages/product-details/components/product-tab-view/tabs/pcf-tab/components/pcf-wizard/PcfWizard.type';
import AmplifyApiService from '../../services/AmplifyApiService';
import IAmplifyApiConfig from '../../shared/interfaces/IAmplifyApiConfig';

const amplifyApiService = new AmplifyApiService();

const BASE_PATH = 'machine-manufacturers';

// Hook for getting manufacturer's list
export const useListManufacturers = (
  options: UseQueryOptions<IManufacturer[], Error> = {},
): UseQueryResult<IManufacturer[]> => {
  const amplifyApiConfig: IAmplifyApiConfig = {
    apiName: 'PacificApi',
    path: BASE_PATH,
  };

  const query = useQuery<IManufacturer[], Error>({
    queryKey: [BASE_PATH],
    queryFn: async (): Promise<IManufacturer[]> => {
      const response = await amplifyApiService.get<IManufacturer[]>(amplifyApiConfig);

      return response;
    },
    ...options,
  });

  return query;
};
